export default __webpack_public_path__ + "static/media/Lara_Lightbody_AHV_In_Moms_We_Trust.8a19c279.jpg";